export const SECTIONS_TYPE = Object.freeze({
  FIXED: 'fixed',
  HOUSE: 'house',
  EXTERNAL_AREA: 'externalArea',
  GENERAL_CONDITIONS: 'generalConditions',
});

export const DEBOUNCE_STORAGE_UPDATE_WAIT_TIME = 2000;

export const PHOTO_SECTION_SLUG = 'photoSession';

export const NOTES_ITEM_SLUG = 'photoSessionNotes';

export const NOTES_MAX_LENGTH = 280;
